<template>
  <div class="container">
    <Carrousel />

    <div class="products">
      <div class="row">
        <div class="col-12 heading text-center mb-4 text-muted">
          <h3>Nuestros productos</h3>
        </div>
        <router-link
          to="/menu#arma_tu_roll"
          class="col-12 col-md-6 col-lg-3 product sushi"
          >Rolls</router-link
        >
        <router-link
          to="/menu#compartir"
          class="col-12 col-md-6 col-lg-3 product sashimi"
          >Sashimi</router-link
        >
        <router-link
          to="/menu#handroll"
          class="col-12 col-md-6 col-lg-3 product handroll"
          >Handroll</router-link
        >
        <router-link
          to="/menu#ceviches"
          class="col-12 col-md-6 col-lg-3 product ceviche"
          >Ceviche</router-link
        >
      </div>

       <hr class="separator" />

      <Ubicacion />

      <div class="text content py-3">
        <span class="heading">Eien Sushi</span>
        <h1>Reparto a domicilio adicional</h1>
        <h3>Cargo de envio segun zona de reparto</h3>
        <h4>*Consulta por disponibilidad</h4>
      </div>
    </div>
  </div>
</template>

<style scoped>
.content {
  background: url("../assets/1.jpg") center center;
  font-family: "Bellefair", Times;
  height: 470px;
}
.products {
  width: 100%;
  display: block;
  max-width: 1400px;
  margin: 40px auto 0;
}
.text {
  padding-top: 250px;
  text-align: center;
}
.separator {
  margin: 50px 0px;
}
.product {
  font-family: "Bellefair", Times;
  height: 650px;
  margin: 0px 0px 0px;
  padding: 5px;
  font-size: 3.5em;
  width: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.8);
}
.product:hover {
  opacity: 0.8;
}
.sushi {
  background: url("/images/home-1-1.jpg") center bottom;
  background-size: cover;
}
.sashimi {
  background: url("/images/home-1-2.jpg") center center;
  background-size: cover;
}
.handroll {
  background: url("/images/home-1-3.jpg") center center;
  background-size: cover;
}
.ceviche {
  background: url("/images/home-1-4.jpg") center center;
  background-size: cover;
}
@media only screen and (max-width: 600px) {
  .product {
    height: 250px;
  }
  .sashimi,
  .sushi,
  .handroll {
    background-size: cover !important;
    background-position: center 450px;
  }
}
</style>

<script>
import Carrousel from "./Carrousel";
import Ubicacion from './Ubicacion.vue'

export default {
  components: {
    Carrousel,
    Ubicacion
  },
};
</script>